<template>
  <div class="drawer-detail">
    <div v-for="field in fields" :key="field" class="field-type">
      <span class="label">{{ translateTag[field] || field }}:</span>
      <!-- <pre class="value company-pre ">{{company[field]}}</pre> -->
      <!-- <tagInputInShow :value="company[field]"></tagInputInShow> -->
      <SearchTagInputShow :value="company[field]" @quickEdit="quickEdit(field)"></SearchTagInputShow>
    </div>
  </div>
</template>
<script>
// import tagInputInShow from '../../../../../company/src/baseComponent/tagInputInShow'
import SearchTagInputShow from './SearchTagInputShow'

export default {
  components: { SearchTagInputShow },
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['公司亮点', '公司劣势'],
      translateTag: {},
    }
  },
  methods: {
    quickEdit(field){
      const { translateTag, company } = this
      this.$emit('quickEdit',{
        value: company[field],
        label:translateTag[field]||field,
        type:'tagInput',
        confirmFunc:async(v)=>{
          const res = await app.service('company').modifyCompany({
            query: { _id: this.company._id },
            data: { [field]: v },
          })
          if (res.status === 'success' || res.status === 200) {
            this.$set(this.company,field,v)
            this.$message.success(`修改成功`)
          }
        },
      })
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
